import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from '@dtsl/css-stacked-button/dist/index.module.css';
import { Button } from '@dtsl/react/dist/components/Button';
import { DatePickers } from '@dtsl/react/dist/components/DatePickers';
import { Dropdown } from '@dtsl/react/dist/components/Dropdown';
function StackedButton(props) {
  const {
    className,
    disabled,
    children
  } = props;
  const groupButtonClass = classNames({
    [styles['sib-stacked-button']]: true,
    [className]: !!className
  });
  return /*#__PURE__*/React.createElement("div", {
    className: groupButtonClass
  }, React.Children.map(children, (child, index) => {
    var _child$props, _child$props2, _child$props3;
    switch (true) {
      case child.type === Dropdown && (child === null || child === void 0 ? void 0 : (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.isDropdownButton):
        return /*#__PURE__*/React.cloneElement(child, {
          key: index,
          disabled: disabled,
          className: styles['sib-dropdown'],
          dropdownButtonMetaData: {
            ...(child === null || child === void 0 ? void 0 : (_child$props2 = child.props) === null || _child$props2 === void 0 ? void 0 : _child$props2.dropdownButtonMetaData),
            className: `${styles['sib-btn_variant--tertiary']} ${styles['dropdown-open']}`
          }
        });
      case child.type === DatePickers:
        return /*#__PURE__*/React.cloneElement(child, {
          key: index,
          disabled: disabled,
          className: styles['sib-datepicker-container'],
          triggerClassName: styles['sib-datepicker-trigger']
        });
      case child.type === Button:
        return /*#__PURE__*/React.cloneElement(child, {
          key: index,
          disabled: disabled,
          className: `${styles['sib-btn']} ${child !== null && child !== void 0 && (_child$props3 = child.props) !== null && _child$props3 !== void 0 && _child$props3.isSelected ? styles['sib-btn--selected'] : ''}`
        });
      default:
        return /*#__PURE__*/React.cloneElement(child, {
          key: index,
          disabled: disabled
        });
    }
  }));
}
StackedButton.defaultProps = {
  className: '',
  disabled: false
};
StackedButton.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
export default StackedButton;